import {request} from '@/helpers/apiClient'
import {PROMOTION_LIST_CONFIG} from '@/utils/constants/apiConfig/promotionListConfig'

export const getPromotionList = async (body, queryParams) =>
  request(PROMOTION_LIST_CONFIG.PROMOTIONS_LIST, {data: body}, queryParams)

export const downloadPromotionList = async (body, queryParams) =>
  request(PROMOTION_LIST_CONFIG.DOWNLOAD_PROMOTIONS_LIST, {data: body}, queryParams)
export const downloadPromotionTemplate = async (body, queryParams) =>
  request(
    PROMOTION_LIST_CONFIG.DOWNLOAD_PROMOTIONS_TEMPLATE,
    {
      responseType: 'arraybuffer',
    },
    ''
  )

export const getPromotionDetail = async promotionId => {
  const config = {...PROMOTION_LIST_CONFIG.PROMOTION_DETAIL}
  config.endPoint = config.endPoint.replace('{promotionId}', promotionId)
  return request(config)
}
